<template lang="pug">
v-dialog(
	v-model="_value"
	:transition="false"
	style="overflow: hidden;"
	persistent
	)
	v-toolbar( :color="colors.primary"
		dark
	)
		v-icon.mr-2 search
		h1.title Búsqueda {{fullMode ? 'Completa' : 'Exacta'}}
		v-progress-circular.loader(
			indeterminate
			v-if="loading"
		)
		div.mt-2.loader.d-flex
			template(
				v-if="!loading && state===1"
				)
				span.pt-1 Exacta
				v-switch.mx-3(
					v-model="fullMode"
					)
				span.pt-1 Completa
			v-btn.close-button(
				icon
				color="red"
				dark
				@click="closeModal"
				)
				v-icon.font-weight-bold(style="margin-left: -1px;") close
	v-card.px-2
		v-text-field(
			v-if="state === 1"
			ref="inp1"
			v-model="alias"
			label="Código Interno"
			outline
			@blur="handleBlur('inp1', $event)"
			@keydown="handleKeyDown($event)"
			@keydown.enter="fetchProducts"
			@keydown.esc="closeModal"
			:disabled="loading"
			)
		alter-auto-complete(
			:search-input="alias"
			ref="inp2"
			v-if="state === 2"
			:items="options"
			outline
			label="producto"
			return-object
			v-model="product"
			@change="selectProduct()"
			@blur="handleBlur('inp2')"
			@keydown="handleKeyDown($event)"
			@item:click="handleClick($event)"
			@keydown.esc="closeModal"
			:disabled="loading"
		)
			v-layout(slot="tail" slot-scope="props")
				v-flex.xs6
					span Stock: {{extractStock(props.item)}}
				v-flex.xs6
					span Precio: ${{extractPrice(props.item)}}
		span.px-2.subheading.green--text(
			v-show="state === 2"
		)
			v-icon.mr-2(color="green darken-3") info
			span {{options.length}} resultados encontrados
		v-layout.py-2.title(wrap v-if="state === 3")
			v-flex.xs8
				span.mx-2 Producto: {{product.name}}
			v-flex.text-xs-right.xs2
				span.mx-2 Precio: {{product.sale_price | mixFormatCurrency}}
			v-flex.text-xs-right.xs2
				span Stock: {{showStock(product)}}
		v-text-field(
			outline
			ref="inp3"                
			label="cantidad"
			v-model="quantity"
			@keydown="handleKeyDown($event)"
			@keydown.enter="addToCart"
			@keydown.esc="closeModal"
			@blur="handleBlur('inp3')"
			v-if="state === 3"
		)
		span.px-2.subheading.red--text(
			v-show="errorMessage"
		)
			v-icon.mr-2(color="red") error
			span Error: {{errorMessage}}
		span.px-2.subheading.green--text(
			v-show="successMessage && state === 1"
		)
			v-icon.mr-2(color="green") info
			span {{successMessage}} agregado a la venta
</template>

<script>
// -- Component Imports --
import AlterAutoComplete from '@/components/AlterAutoComplete/AlterAutoComplete'
// -- JS Data files import --
// -- JS Libraries Import --
import helper from '../../services/API/helpers/ProductHelper'
import ProductModel from '../../models/Warehouse/WhProduct'
import axios from 'axios'
// -- Mixins imports --
import InputValidations from '../../mixins/InputValidations'
import CurrencyUtils from '../../mixins/CurrencyUtils'
// -- Vuex Imports --
import { mapGetters, mapActions, mapState } from 'vuex'
// -- Other Imports --
export default {
    name: 'internal-code-search-modal',
    props: {
        // ------------------------- UI State ---------------------------------
        /**
         * @description
         */
        value: {
            type: Boolean,
            default: () => false,
        },
        // ------------------------- Component Data ---------------------------
    },
    data: function() {
        return {
            // ------------------------ UI State ------------------------------
            loading: false,
            state: 1,
            // ------------------------ Data storing --------------------------
            alias: '',
            product: null,
            quantity: '',
            errorMessage: '',
            successMessage: '',
            options: [],
            fullMode: false,
        }
    },
    computed: {
        // -------------------- Editable props binding-------------------------
        /**
         * @description
         */
        _value: {
            get: function() {
                return this.value
            },
            set: function(val) {
                this.$emit('input', val)
            },
        },
        // -------------------- Alias settings --------------------------------
        // -------------------- Dynamic UI State ------------------------------
        // -------------------- Displayed data --------------------------------
        // -------------------- Methods data ----------------------------------
        // -------------------- Vuex mappings ---------------------------------
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
        ...mapState('CartModule', {
            items: 'items',
        }),
        ...mapGetters('AuthModule', {
            branchOfficeID: 'branchOfficeID',
        }),
    },
    methods: {
        // -------------------- UI Modification -------------------------------
        initialData() {
            return {
                loading: false,
                state: 1,
                alias: '',
                product: null,
                quantity: '',
                errorMessage: '',
                successMessage: '',
                options: [],
                fullMode: false,
            }
        },
        resetData() {
            Object.assign(this.$data, this.initialData())
        },
        closeModal() {
            this.resetData()
            this.$emit('input', false)
        },
        // -------------------- Data fetching ---------------------------------
        fetchProducts() {
            this.successMessage = ''
            const limit = this.fullMode ? 3 : 1
            if (this.alias.length < limit) {
                this.errorMessage = `Deben ingresarse al menos ${limit} caractéres`
                return
            }
            this.errorMessage = ''
            this.loading = true
            let route =
                process.env.VUE_APP_API_ROUTE +
                `/wh_product_slim_multiple_filter?search_string=${this.alias}`
            if (!this.fullMode) {
                route =
                    process.env.VUE_APP_API_ROUTE +
                    `/wh_product_slim_filter_alias_name?alias_name=${
                        this.alias
                    }`
            }
            let ms = 10000
            const timeout = new Promise((resolve, reject) => {
                let id = setTimeout(() => {
                    clearTimeout(id)
                    reject({
                        response: {
                            data: { message: 'tiempo de espera agotado' },
                        },
                    })
                }, ms)
            })
            let promise = axios.get(route)
            Promise.race([promise, timeout])
                .then(response => {
                    if (response.data.data.length > 1) {
                        this.options = response.data.data
                            .map(itm => {
                                itm.text = `${itm.alias_name} - ${itm.name}`
                                let sortPrice = 0
                                if (itm.prices && itm.prices.length) {
                                    sortPrice = itm.prices.find(
                                        pr =>
                                            pr.g_branch_office_id ===
                                            this.branchOfficeID
                                    )
                                }
                                itm.sortPrice = sortPrice
                                    ? sortPrice.sale_price
                                    : 999999
                                return itm
                            })
                            .sort((prev, cur) => prev.sortPrice - cur.sortPrice)

                        this.state = 2
                        this.loading = false
                        // return response
                    } else if (response.data.data.length === 1) {
                        this.product = response.data.data[0]
                        this.selectProduct()
                    } else {
                        this.errorMessage = !this.fullMode
                            ? 'No se encontraron productos con este código'
                            : 'No se encontraron productos para esta búsqueda'
                        this.loading = false
                        this.$nextTick(() => this.$refs.inp1.focus())
                    }
                })
                .catch(e => {
                    let data = e.response.data
                    if (data.data) data = data.data
                    this.errorMessage = data.message
                    this.loading = false
                    this.handleBlur('inp1')
                })
        },
        selectProduct(id = this.product.id) {
            this.loading = true
            ProductModel.append('sale_prices', 'stocks', 'virtual_offer_price')
                .include('sl_wholesale_discounts', 'wh_product_upc_code')
                .find(id)
                .then(res => {
                    try {
                        this.product = helper.frontendProduct(res)
                    } catch (e) {
                        this.product = null
                        this.errorMessage =
                            'Error de configuración del producto, contactar al departamento de informática'
                        this.state = 1
                        this.loading = false
                        let err = {
                            response: {
                                data: {
                                    message:
                                        'Error de configuración del producto, contactar al departamento de informática',
                                },
                            },
                        }
                        throw e
                        return
                    }
                    this.state = 3
                    this.loading = false
                })
                .catch(e => {
                    this.errorMessage =
                        e.response && e.response.data && e.response.data.message
                            ? e.response.data.message
                            : 'Ha ocurrido un error'
                    this.state = 2
                    this.loading = false
                })
        },
        // -------------------- Data handling and transformations -------------
        addToCart() {
            let quantity = this.quantity || 1
            let product = this.product
            product.quantity = quantity
            // let items = [...this.items, product]
            let ver = true
            let items = this.items.map(itm => {
                if (itm.id === product.id) {
                    itm.quantity =
                        parseFloat(itm.quantity) + parseFloat(product.quantity)
                    ver = false
                }
                return itm
            })
            if (ver) items = [...items, product]
            this.setCartItems(items)
            let message = product.name
            this.resetData()
            this.successMessage = message
        },
        showStock(product) {
            if (product && (product.stock === 0 || product.stock)) {
                return this.formatNumber(product.stock)
            }
            return 'ERR'
        },
        // -------------------- Validations and Error handling ----------------
        // -------------------- Other functions -------------------------------
        handleBlur(ref = 'inp1') {
            this.$nextTick(() => this.$refs[ref].focus())
        },
        handleKeyDown(e) {
            if (e.keyCode === 123) this._value = false
            if (e.keyCode === 112) {
                if (this.state === 1) return
                this.resetData()
            }
            if (e.keyCode === 113) {
                if (this.state > 1) return
                this.fullMode = !this.fullMode
            }
            if (e.keyCode === 114) {
                if (this.state > 1) return
                this.$emit('mode:multi')
                this._value = false
            }
        },
        handleClick(idx) {
            this.selectProduct(this.options[idx].id)
        },
        formatNumber(number, prefix = '') {
            if (isNaN(number)) number = parseFloat(number)
            let n = number
            n = parseFloat(n.toString())
            return prefix + this.mixCurrencyFormatter(n)
        },
        // -------------------- Vuex mappings ---------------------------------
        ...mapActions('CartModule', {
            setCartItems: 'setCartItems',
        }),
        extractStock(item) {
            if (!item) return 'ERR'
            if (!item.stocks) {
                return ''
            }
            //TODO: Pedir sucursal de la bodega al backend
            if (!item.stocks || !item.stocks.length) return 'NO FIJADO'
            let stock = item.stocks
                .filter(st => st.g_branch_office_id === this.branchOfficeID)
                .reduce((sum, wh) => {
                    sum += wh.stock
                    return sum
                }, 0)
            return this.formatNumber(stock)
        },
        extractPrice(item) {
            if (!item.prices) return 'NO FIJADO'
            let price = item.prices.find(
                pr => pr.g_branch_office_id === this.branchOfficeID
            )
            return price && (price.sale_price === 0 || price.sale_price)
                ? this.formatNumber(price.sale_price)
                : 'NO FIJADO'
        },
        test(e) {
            alert('test')
        },
    },
    watch: {
        value: {
            handler(val) {
                this.resetData()
                if (val) {
                    this.$nextTick(() => this.$refs.inp1.focus())
                } else {
                }
            },
            inmediate: true,
        },
        state: {
            handler(val) {
                this.$nextTick(() => this.$refs[`inp${val}`].focus())
            },
        },
        quantity: {
            handler(val, oldval) {
                this.$nextTick(
                    () => (this.quantity = this.mixWatchDecimal(val, oldval))
                )
            },
            immediate: true,
        },
    },
    components: {
        'alter-auto-complete': AlterAutoComplete,
    },
    mixins: [InputValidations, CurrencyUtils],
    // filters: {},
    // ------------------------ Lifecycle Methods -----------------------------
    // ------------------------ End Lifecycle Methods -------------------------
}
</script>

<style lang="scss">
.loader {
    position: absolute;
    right: 30px;
}
.close-button {
    margin-top: -3px !important;
    margin-left: 25px !important;
}
</style>
